import Image from "next/image";
import { useTranslation } from "react-i18next";
import { ifArabic, getLocalizedPath } from "@/utils/language";
import { useLanguage } from "@/app/[lang]/client/language-context";

// images
import thumb_1 from "@/assets/img/about/thumb1.jpg";
import thumb_2 from "@/assets/img/about/thumb2.jpg";

import CounterItem from "../counter/counter-item";
import Link from "next/link";
import { ArrowIcons } from "../svg";

export default function AboutOne() {
  const { t } = useTranslation();
  const { language } = useLanguage();

  return (
    <section className="about-area pt-70 pb-70">
      <div className="container">
        <div className="row align-items-center">
          {/* Left side images & counter */}
          <div className="col-lg-6">
            <div className="tp-about-wrap wow fadeInLeft" data-wow-delay=".3s">
              <div className="tp-about-thumb-wrapper">
                <div className="tp-about-thumb-1">
                  <Image
                    src={thumb_1}
                    alt={t("about_thumb1_alt")}
                    width={300}
                    height={400}
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="tp-about-thumb-2">
                  <Image
                    src={thumb_2}
                    alt={t("about_thumb2_alt")}
                    width={300}
                    height={400}
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </div>
              <div className="tp-about-exprience">
                <div className="tp-about-exprience-text d-flex">
                  <p>
                    {t("about_experience_prefix")}
                    <br />
                    {t("about_experience_since")}
                  </p>
                  <h2 className="tp-about-exprience-count">
                    <CounterItem min={1000} max={2017} />
                  </h2>
                </div>
              </div>
            </div>
          </div>

          {/* Right side text */}
          <div className="col-lg-6">
            <div
              className="tp-about-wrapper wow fadeInRight"
              data-wow-delay=".3s"
            >
              <div className="tp-section mb-40">
                <h2 className="tp-section-title mb-20">
                  {t("about_section_title_1")} <br />{" "}
                  {t("about_section_title_2")} <span>HTU</span>
                </h2>
                <p>{t("home_about")}</p>
              </div>
              <div className="tp-about-list">
                <div className="tp-about-btn pt-5">
                  <Link
                    aria-label="Know more about HTU"
                    className="tp-btn"
                    href={getLocalizedPath("/about-htu", language)}
                  >
                    {t("about_learn_more")}
                    <span>
                      {ifArabic(
                        <ArrowIcons.LeftArrow />,
                        <ArrowIcons.RightArrow />
                      )}
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
